// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3NC__","itemTitle":"ClientEmergencyInfo_itemTitle__2_uB2","itemText":"ClientEmergencyInfo_itemText__3GbxW"};